export enum LiabilitiesDelegateMode {
  SINGLE = 'SINGLE',
  MULTIPLE = 'MULTIPLE',
}
